// front end and back end connectivity
export const API = "https://chat-box-9eog.onrender.com"